import React, { Fragment, SFC } from 'react';
import Hero from './organisms/Hero';
import Services from './organisms/Services';
import RelatedStories from './organisms/RelatedStories';
import LatestNews from './organisms/LatestNews';
import Events from './organisms/Events';
import ContactUs from './organisms/ContactUs';
import ColocationsAndNetworks from './organisms/ColocationsAndNetworks';
import gql from 'graphql-tag';
import { DataProps, graphql } from 'react-apollo';
import { HomeQuery as Response } from '../entities/operationResults';
import { compose } from 'recompose';
import { RouteComponentProps, withRouter } from 'react-router';
import { ExchangeParams } from './Exchange';
import { path } from 'ramda';
import ContactSlideover from './organisms/ContactSlideover';
import withSpinner from '../hocs/withSpinner';
import ComingSoon from './molecules/ComingSoon';
import comingSoonHandles from '../constants/comingSoonHandles';
import Container from './atoms/Container';

const GET_HOME_QUERY = gql`
    query Home ($site: [String!]) {
        exchangePage: entries(site:$site, section: "exchangePage") {
            ... on exchangePage_Entry {
                contactFormText {
                    html
                }
                contactBlockCtaText {
                    html
                }
            }
        }
    }
`;

type Props = DataProps<Response> & RouteComponentProps<ExchangeParams>;

const Home: SFC<Props> = ({ data }) => {
    const contactFormText = path<string>(['exchangePage', 0, 'contactFormText', 'html'], data || {});
    const contactBlockCtaText = path<string>(['exchangePage', 0, 'contactBlockCtaText', 'html'], data || {});

    return (
        <Fragment>
            {comingSoonHandles.includes(data.variables.site) &&
                <ComingSoon/>
            }
            {!comingSoonHandles.includes(data.variables.site) &&
                <Fragment>
                    <Hero />
                    <ColocationsAndNetworks />
                    <Services />
                    <RelatedStories />
                    <LatestNews />
                    <Events />
                </Fragment>
            }
            <Container maxWidth paddingBottom={'6rem'} paddingBottomL={'9.6rem'} marginTopL={'-6.6rem'} className={'pre-footer'}>
                <ContactUs slideover={ContactSlideover} contactFormText={contactFormText} ctaText={contactBlockCtaText} />
            </Container>
        </Fragment>
    );
};

const enhance = compose(
    withRouter,
    graphql(GET_HOME_QUERY, {
        options: ((props: Props) => ({
            variables: {
                site: props.match.params.exchange
            }
        }))
    }),
    withSpinner
);
export default enhance(Home);
